// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"SimplePopup_popupContainer__3vwtk","popupCard":"SimplePopup_popupCard__3WKbe"};